import axios from "./axios-auth";

const getSecurityRoles = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getsecurityroles",
      method: "GET",
      params: params,
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        console.log(err);
      });
  });

const getSecurityRolesById = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getsecurityrolesbyid",
      method: "GET",
      params: params,
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        console.log(err);
      });
  });

const getScripts = () =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getscripts",
      method: "GET",
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        console.log(err);
      });
  });

const addSecurityRole = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/addsecurityrole",
      method: "POST",
      data: payload,
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        console.log(err);
      });
  });

const editSecurityRole = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/editsecurityrole",
      method: "PUT",
      data: payload,
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        console.log(err);
      });
  });

const deleteSecurityRole = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/deletesecurityrole",
      method: "DELETE",
      params: params,
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        console.log(err);
      });
  });

export {
  getSecurityRoles,
  getSecurityRolesById,
  getScripts,
  addSecurityRole,
  editSecurityRole,
  deleteSecurityRole,
};
